import React from 'react';
import hexagon from '../assets/hexagon.png';

const LOGOS = [
  [
    {
      url: "https://api.iconify.design/logos:adobe-photoshop.svg",
      name: "Adobe Photoshop",
    },
    {
      url: "https://api.iconify.design/logos:adobe-illustrator.svg",
      name: "Adobe Illustrator",
    },
    {
      url: "https://api.iconify.design/logos:figma.svg",
      name: "Figma",
    },
    
    
   
  ],

  [
     {
      url: "https://api.iconify.design/logos:notion-icon.svg",
      name: "Notion",
    },
    {
      url: "https://api.iconify.design/logos:adobe-premiere.svg",
      name: "Adobe Premiere Pro",
    },
    {
      url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='45' fill='%2300C4CC'/%3E%3Ctext x='50' y='65' text-anchor='middle' font-size='55' font-family='Arial' fill='white'%3EC%3C/text%3E%3C/svg%3E",
      name: "Canva",
    },
    {
      url: "https://api.iconify.design/logos:wordpress-icon.svg",
      name: "WordPress",
    },
    
    
  ],

  [
    {
      url: "https://api.iconify.design/logos:google-drive.svg",
      name: "Google Drive",
    },
    {
      url: "https://api.iconify.design/logos:pinterest.svg",
      name: "Pinterest",
    },
    {
      url: "https://api.iconify.design/logos:react.svg",
      name: "React",
    },
    
    
    
  ],

  [
    {
      url: "https://api.iconify.design/logos:webflow.svg",
      name: "Webflow",
    },
    {
      url: "https://api.iconify.design/logos:google-gemini.svg",
      name: "Gemini AI",
    },
    {
      url: "https://api.iconify.design/logos:claude-icon.svg",
      name: "Claude AI",
    },
    {
      url: "https://api.iconify.design/logos:github-icon.svg",
      name: "GitHub",
    },
    
    
  ],

  [
    {
      url: "https://api.iconify.design/logos:adobe.svg",
      name: "Adobe Fonts",
    },
    {
      url: "https://api.iconify.design/simple-icons:googledocs.svg",
      name: "Google Docs",
    },
    {
      url: "https://api.iconify.design/simple-icons:googlefonts.svg",
      name: "Google Fonts",
    },
  ],
];
// Flatten all logos for the mobile grid
const ALL_LOGOS = LOGOS.flat();

const HEX_ROWS = [
  [1, 1, 1],
  [1, 1, 1, 1],
  [1, 1, 1],
  [1, 1, 1, 1],
  [1, 1, 1],
];

const DesignTools = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

        .dt-section {
          width: 100%;
          background: #0a0a0a;
          font-family: 'Poppins', sans-serif;
          overflow: hidden;
        }

        .dt-header {
          max-width: 900px;
          margin: 0 auto;
          text-align: center;
          padding: 64px 24px 0;
        }

        .dt-label {
          font-size:20px;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: 0em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 10px;
          width: fit-content; 
          margin: 0 auto 10px;
          
        }

        .dt-heading {
          font-size: 36px;
          font-weight: 700;
          color: #ffffff;
          margin: 0;
          letter-spacing: -0.01em;
          line-height: 40px;
        }

        /* ══════════════════════════════
           DESKTOP HEX GRID
        ══════════════════════════════ */
        .hex-grid {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 52px;
          user-select: none;
          padding-bottom: 60px;
        }

        .hex-cell {
          width: 320px;
          height: 320px;
          margin-right: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .hex-cell .glow-ring {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 5;
          pointer-events: none;
        }
        .hex-cell:hover .glow-ring { opacity: 1; }

        .hex-cell .hex-img {
          width: 95%;
          opacity: 0.55;
          transition: all 0.3s ease-out;
          transform: scale(1);
          filter: brightness(0.35) saturate(0.5);
          z-index: 10;
          position: relative;
        }
        .hex-cell:hover .hex-img {
          transform: scale(1.08) translateY(-6px);
          opacity: 0.9;
          filter: brightness(0.55) saturate(0.8);
        }

        .hex-cell .logo-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 20;
          padding-left: 24px;
          padding-bottom: 64px;
        }

        .hex-cell .logo-img {
          width: 52px;
          height: 52px;
          object-fit: contain;
          transition: transform 0.3s ease, filter 0.3s ease;
        }
        .hex-cell:hover .logo-img {
          transform: scale(1.3);
          filter: brightness(1) grayscale(0);
        }

        .hex-cell .logo-name {
          margin-top: 10px;
          font-size: 0.78rem;
          font-weight: 500;
          color: #ffffff;
          opacity: 0;
          transition: opacity 0.25s ease;
          white-space: nowrap;
        }
        .hex-cell:hover .logo-name { opacity: 1; }

        .hex-cell .puddle {
          position: absolute;
          bottom: 22px;
          left: 50%;
          transform: translateX(-42%);
          width: 130px;
          height: 16px;
          border-radius: 50%;
          background: radial-gradient(ellipse, rgba(181,93,208,0.6) 0%, rgba(18,154,220,0.3) 55%, transparent 80%);
          filter: blur(9px);
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 3;
        }
        .hex-cell:hover .puddle { opacity: 1; }

        /* ══════════════════════════════
           MOBILE GRID  (≤ 767px)
           Simple responsive icon grid
        ══════════════════════════════ */
        .mobile-grid {
          display: none;
        }

        .mobile-tool-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 16px 8px;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 16px;
          transition: background 0.2s, border-color 0.2s, transform 0.2s;
        }
        .mobile-tool-card:active {
          transform: scale(0.95);
          background: rgba(255,255,255,0.08);
          border-color: rgba(181,93,208,0.4);
        }
        .mobile-tool-card img {
          width: 36px;
          height: 36px;
          object-fit: contain;
        }
        .mobile-tool-card span {
          font-size: 0.65rem;
          font-weight: 500;
          color: rgba(255,255,255,0.6);
          text-align: center;
          white-space: nowrap;
        }

        @media (max-width: 767px) {
          .dt-header {
            padding: 48px 20px 0;
          }
          /* Hide desktop hex grid */
          .hex-grid {
            display: none;
          }
          /* Show mobile grid */
          .mobile-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
            padding: 36px 20px 56px;
            max-width: 480px;
            margin: 0 auto;
          }
        }

        /* Tablet: shrink hex cells so they don't overflow */
        @media (min-width: 768px) and (max-width: 1100px) {
          .hex-cell {
            width: 220px;
            height: 220px;
            margin-right: 20px;
          }
          .hex-cell .logo-img {
            width: 38px;
            height: 38px;
          }
          .hex-grid > div {
            /* recalculate overlap at smaller cell size */
          }
        }
      `}</style>

      <div className="dt-section">
        {/* Header */}
        <div className="dt-header">
          <p className="dt-label">OUR DESIGN TOOLS</p>
          <h2 className="dt-heading">No magic! just the right tools</h2>
        </div>

        {/* ── DESKTOP: original hex grid ── */}
        <div className="hex-grid">
          {HEX_ROWS.map((row, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: i % 2 !== 0 ? '-225px' : (i === 0 ? '0' : '-215px'),
              }}
            >
              {row.map((show, j) =>
                show ? (
                  <div key={j} className="hex-cell">
                    {/* Gradient glow border ring */}
                    <svg className="glow-ring" viewBox="0 0 200 230" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <linearGradient id={`hg-${i}-${j}`} x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#129ADC" />
                          <stop offset="35%" stopColor="#B55DD0" />
                          <stop offset="70%" stopColor="#E154AA" />
                          <stop offset="100%" stopColor="#F45A39" />
                        </linearGradient>
                        <filter id={`gblur-${i}-${j}`}>
                          <feGaussianBlur stdDeviation="3" />
                        </filter>
                      </defs>
                      <polygon
                        points="100,8 180,52 180,140 100,184 20,140 20,52"
                        fill="none"
                        stroke={`url(#hg-${i}-${j})`}
                        strokeWidth="6"
                        strokeLinejoin="round"
                        filter={`url(#gblur-${i}-${j})`}
                        transform="translate(1,-18) rotate(90 100 100) scale(0.94)"
                      />
                      <polygon
                        points="100,8 180,52 180,140 100,184 20,140 20,52"
                        fill="none"
                        stroke={`url(#hg-${i}-${j})`}
                        strokeWidth="4"
                        strokeLinejoin="round"
                        filter="drop-shadow(0 0 8px rgba(181,93,208,0.35))"
                        transform="translate(1,-18) rotate(90 100 100) scale(0.94)"
                      />
                    </svg>

                    <div className="puddle" />
                    <img src={hexagon} alt="hex" className="hex-img" />

                    {LOGOS[i]?.[j] && (
                      <div className="logo-overlay">
                        <img src={LOGOS[i][j].url} alt={LOGOS[i][j].name} className="logo-img" />
                        <span className="logo-name">{LOGOS[i][j].name}</span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div key={j} style={{ width: 160, height: 160 }} />
                )
              )}
            </div>
          ))}
        </div>

        {/* ── MOBILE: clean icon grid ── */}
        <div className="mobile-grid">
          {ALL_LOGOS.map((tool) => (
            <div key={tool.name} className="mobile-tool-card">
              <img src={tool.url} alt={tool.name} />
              <span>{tool.name}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DesignTools;